(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-auto-submit]')) e.target.form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class LeonlyProduct {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('[data-product-form]');
      this.dev = this.form && this.form.hasAttribute('data-dev-mode');
      const json = root.querySelector('[data-variants]');
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.error = root.querySelector('[data-form-error]');
      this.maxBytes = Number(root.dataset.maxMb || 20) * 1024 * 1024;
      this.initGallery();
      if (!this.form) return;
      this.form.addEventListener('change', (e) => this.onChange(e));
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
      const app = this.form.querySelector('.pdp__app');
      if (app) {
        const sync = () => setTimeout(() => this.syncFromVariantId(), 0);
        app.addEventListener('change', sync);
        app.addEventListener('click', sync);
        const guard = (e) => {
          if (!(e.target instanceof Element) || !this.root.contains(e.target)) return;
          if (e.type === 'click' && !e.target.closest('[data-add-button]')) return;
          if (e.type === 'submit' && e.target !== this.form) return;
          if (this.checkAppRequired()) return;
          e.preventDefault();
          e.stopImmediatePropagation();
        };
        window.addEventListener('click', guard, true);
        window.addEventListener('submit', guard, true);
        this.initAppDefault(app);
      }
      this.root.querySelectorAll('[data-photo-input]').forEach((input) => this.bindPhoto(input));
      this.root.querySelectorAll('[data-photo-clear]').forEach((btn) => btn.addEventListener('click', () => this.clearPhoto(btn.closest('[data-slot]'))));
      this.syncPets();
      this.initSticky();
    }

    selectedOptions() {
      return [...this.form.querySelectorAll('[data-option-group]')].map((group) => {
        if (group.hasAttribute('data-toggle')) {
          return group.querySelector('input').checked ? group.dataset.on : group.dataset.off;
        }
        return group.querySelector('input:checked')?.value;
      });
    }

    onChange(e) {
      if (e.target.matches('[data-option-input]')) {
        const opts = this.selectedOptions();
        const variant = this.variants.find((v) => v.options.every((o, i) => o === opts[i]));
        this.applyVariant(variant);
      }
      if (e.target.matches('[data-pets]')) {
        this.setPrice(e.target.dataset.price, null);
      }
      this.syncPets();
    }

    initAppDefault(app) {
      const initial = this.variants.find((v) => v.id === Number(this.form.querySelector('[data-variant-id]').dataset.initialVariant));
      if (!initial) return;
      let tries = 0;
      const apply = () => {
        const swatches = [...app.querySelectorAll('[data-ownprint-swatch]')];
        if (!swatches.length) {
          if (tries++ < 40) setTimeout(apply, 100);
          return;
        }
        const label = (el) => (el.getAttribute('aria-label') || el.dataset.value || el.textContent).trim();
        const order = [];
        this.variants.forEach((v) => v.options.forEach((o) => { if (!order.includes(o)) order.push(o); }));
        const parent = swatches[0].parentElement;
        swatches
          .filter((el) => el.parentElement === parent && order.includes(label(el)))
          .sort((a, b) => order.indexOf(label(a)) - order.indexOf(label(b)))
          .forEach((el) => parent.appendChild(el));
        const target = swatches.find((el) => initial.options.includes(label(el)));
        if (target) target.click();
      };
      apply();
    }

    checkAppRequired() {
      const missing = [...this.form.querySelectorAll('.pdp__app [required]')].find((input) => {
        if (input.disabled || input.closest('[hidden]')) return false;
        return input.type === 'file' ? !(input.files && input.files.length) : !String(input.value).trim();
      });
      if (!missing) {
        this.hideError();
        return true;
      }
      const label = this.form.querySelector(`label[for="${missing.id}"]`);
      const name = label ? label.textContent.replace('*', '').trim() : '';
      this.error.textContent = name ? `${this.root.dataset.textAppRequired} ${name}` : this.root.dataset.textPhotoRequired;
      this.error.hidden = false;
      missing.focus();
      return false;
    }

    syncFromVariantId() {
      const id = Number(this.form.querySelector('[data-variant-id]').value);
      const variant = this.variants.find((v) => v.id === id);
      if (variant && variant.id !== this.syncedId) {
        this.syncedId = variant.id;
        this.applyVariant(variant);
      }
    }

    applyVariant(variant) {
      const btn = this.form.querySelector('[data-add-button]');
      const label = this.form.querySelector('[data-add-label]');
      const addPrice = this.form.querySelector('[data-add-price]');
      if (!variant) {
        btn.disabled = true;
        label.textContent = this.root.dataset.textUnavailable || 'Unavailable';
        addPrice.textContent = '';
        return;
      }
      this.form.querySelector('[data-variant-id]').value = variant.id;
      this.setPrice(variant.price, variant.compare);
      btn.disabled = !variant.available;
      label.textContent = variant.available ? this.root.dataset.textAdd : this.root.dataset.textSoldOut;
      addPrice.textContent = variant.available ? ` · ${variant.price}` : '';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    setPrice(price, compare) {
      const now = this.root.querySelector('[data-price-now]');
      if (now) now.textContent = price;
      const was = this.root.querySelector('[data-price-was]');
      if (was) was.hidden = !compare;
      const sticky = this.root.querySelector('[data-sticky-price]');
      if (sticky) sticky.textContent = price;
    }

    petCount() {
      const pets = this.form.querySelector('[data-pets]:checked');
      if (pets) return Number(pets.dataset.pets) || 1;
      const group = this.form.querySelector('[data-pet-group]');
      if (!group) return 1;
      const checked = group.querySelector('input:checked');
      if (!checked) return 1;
      const n = parseInt(checked.value, 10);
      if (!Number.isNaN(n)) return n;
      return [...group.querySelectorAll('input')].indexOf(checked) + 1;
    }

    syncPets() {
      const count = this.petCount();
      const slots = this.root.querySelectorAll('[data-slot]');
      slots.forEach((slot, i) => {
        const active = i < count;
        slot.hidden = !active;
        slot.querySelectorAll('input').forEach((input) => { input.disabled = !active; });
      });
      const single = count === 1;
      this.root.querySelectorAll('[data-slot-title]').forEach((t) => {
        t.textContent = single ? t.dataset.single : t.dataset.multi;
      });
    }

    bindPhoto(input) {
      input.addEventListener('change', () => {
        const slot = input.closest('[data-slot]');
        const file = input.files && input.files[0];
        this.hideError();
        slot.classList.remove('has-error');
        if (!file) return this.clearPhoto(slot, true);
        if (file.type && !file.type.startsWith('image/')) {
          input.value = '';
          return this.showError(this.root.dataset.textWrongType, slot);
        }
        if (file.size > this.maxBytes) {
          input.value = '';
          return this.showError(this.root.dataset.textTooLarge, slot);
        }
        const preview = slot.querySelector('[data-photo-preview]');
        if (preview.dataset.url) URL.revokeObjectURL(preview.dataset.url);
        const url = URL.createObjectURL(file);
        preview.dataset.url = url;
        preview.innerHTML = '';
        const img = new Image();
        img.alt = '';
        img.src = url;
        img.onerror = () => { preview.innerHTML = ''; preview.textContent = file.name; };
        preview.appendChild(img);
        slot.querySelector('[data-photo-name]').textContent = file.name;
        slot.classList.add('has-photo');
      });
    }

    clearPhoto(slot, keepFocus) {
      const input = slot.querySelector('[data-photo-input]');
      const preview = slot.querySelector('[data-photo-preview]');
      if (preview.dataset.url) URL.revokeObjectURL(preview.dataset.url);
      preview.innerHTML = '';
      delete preview.dataset.url;
      input.value = '';
      slot.querySelector('[data-photo-name]').textContent = '';
      slot.classList.remove('has-photo');
      if (!keepFocus) input.focus();
    }

    onSubmit(e) {
      const missing = [...this.root.querySelectorAll('[data-slot]:not([hidden])')].filter((slot) => {
        const input = slot.querySelector('[data-photo-input]');
        return input && !(input.files && input.files.length);
      });
      if (missing.length) {
        e.preventDefault();
        this.showError(this.root.dataset.textPhotoRequired, missing[0]);
        missing[0].querySelector('[data-photo-input]').focus();
        return;
      }
      if (this.dev) {
        e.preventDefault();
        this.showError(this.root.dataset.textDevSubmit);
        return;
      }
      const btn = this.form.querySelector('[data-add-button]');
      btn.setAttribute('aria-busy', 'true');
    }

    showError(message, slot) {
      if (slot) slot.classList.add('has-error');
      this.error.textContent = message;
      this.error.hidden = false;
    }

    hideError() {
      this.error.hidden = true;
      this.error.textContent = '';
    }

    initGallery() {
      const list = this.root.querySelector('[data-gallery]');
      if (!list) return;
      const slides = list.querySelectorAll('.pdp__slide');
      const total = this.root.querySelector('[data-gallery-total]');
      const index = this.root.querySelector('[data-gallery-index]');
      if (total) total.textContent = slides.length;
      if (!('IntersectionObserver' in window) || !index) return;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) index.textContent = [...slides].indexOf(entry.target) + 1;
        });
      }, { root: list, threshold: 0.6 });
      slides.forEach((s) => io.observe(s));
    }

    initSticky() {
      const bar = this.root.querySelector('[data-sticky-cta]');
      const target = this.form;
      if (!bar || !target || !('IntersectionObserver' in window)) return;
      bar.hidden = false;
      const io = new IntersectionObserver(([entry]) => {
        const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
      });
      io.observe(target);
      bar.querySelector('[data-sticky-go]')?.addEventListener('click', (e) => {
        e.preventDefault();
        const slot = this.root.querySelector('[data-slot]:not([hidden]) [data-photo-input]');
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        if (slot) slot.focus({ preventScroll: true });
      });
    }
  }

  const initLeonlyProducts = (scope) => {
    scope.querySelectorAll('.pdp').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      new LeonlyProduct(root);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initLeonlyProducts(document));
  } else {
    initLeonlyProducts(document);
  }
  document.addEventListener('shopify:section:load', (e) => initLeonlyProducts(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (target && target.tagName === 'DETAILS') target.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const load = (scope) => {
      scope.querySelectorAll('[data-related-url]').forEach((target) => {
        if (target.dataset.loaded || target.children.length) return;
        target.dataset.loaded = 'true';
        fetch(target.dataset.relatedUrl)
          .then((r) => (r.ok ? r.text() : ''))
          .then((html) => {
            if (!html) return;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('[data-related-url]');
            if (fresh && fresh.innerHTML.trim()) {
              target.innerHTML = fresh.innerHTML;
            } else {
              target.closest('.related')?.setAttribute('hidden', '');
            }
          })
          .catch(() => {});
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => load(document));
    else load(document);
    document.addEventListener('shopify:section:load', (e) => load(e.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
